module.exports = __webpack_public_path__ + "img/tantan.6c919376.png";